<template>
<form @submit.prevent="on_submit" id="submit_form">
    <div class="row my-4">
        <div class="col-12 col-md-6 my-2">
            <label for="first_name_fa" v-text="$t('label.first_name')"></label>
            <input  type="text"
                    :disabled="!form_data.is_editable"
                    id="first_name_fa"
                    name="first_name_fa"
                    class="form-control"
                    v-model="form_data.first_name_fa">
        </div>

        <div class="col-12 col-md-6 my-2">
            <label for="last_name_fa" v-text="$t('label.last_name')"></label>
            <input  type="text"
                    :disabled="!form_data.is_editable"
                    id="last_name_fa"
                    name="last_name_fa"
                    class="form-control"
                    v-model="form_data.last_name_fa">
        </div>

        <div class="col-12 col-md-6 my-2">
            <label for="cellphone_number" v-text="$t('label.phone')"></label>
            <input  type="text"
                    :disabled="!form_data.is_editable"
                    id="cellphone_number"
                    name="cellphone_number"
                    class="form-control"
                    v-model="form_data.cellphone_number">
        </div>
    </div>

    <hr class="custom_hr">

    <div class="row my-4">
        <div class="col-12 col-md-6 my-2">
            <label>
                <span v-text="$t('label.sheba_numbers')"></span>&nbsp;
                <span class="text-success" v-text="$t('btn.add')" style="cursor: pointer !important;" @click="add_sheba_number_input()"></span>
            </label>
            <div v-for="index in sheba_numbers_length" :key="index" class="my-2">
                <div class="input-group" dir="ltr">
                    <div class="input-group-prepend">
                        <span class="input-group-text">IR</span>
                    </div>
                    <input  type="text"
                            dir="ltr"
                            :disabled="!form_data.is_editable"
                            :name="'sheba_number_' + index"
                            :id="'sheba_number_' + index"
                            :class="['form-control sheba_number_inputs', form_meta_data.invalid_sheba_numbers.includes(index - 1) ? 'invalid-sheba-number-input': '']"
                            v-model="form_data.sheba_numbers[index - 1]">
                    <div style="position: absolute; right: 6px; top: 6px; cursor: pointer;" class="text-danger p-1" v-text="$t('btn.delete')" @click="removeSheba(index - 1)"></div>
                </div>
            </div>
        </div>
        <div class="col-12 my-2 text-danger" v-if="form_meta_data.invalid_sheba_numbers.length > 0">
            <span>
                <i class="fas fa-exclamation-triangle"></i>
                <span class="mx-2" v-text="$t('stakeholders.error.invalid_sheba_numbers')"></span>
            </span>
        </div>
    </div>

    <div class="my-4" v-if="form_data.is_editable">
        <button type="submit"
                class="btn btn-success"
                :disabled="form_meta_data.submit_btn_progress"
        >
            <div class="d-flex align-items-center">
                <div v-text="form_meta_data.submit_btn_text"></div>
                <div v-if="form_meta_data.submit_btn_progress" class="ml-2 spinner-border spinner-border-sm" role="status"></div>
            </div>
        </button>
    </div>
</form>
</template>

<script>
import $ from 'jquery';
import { i18n } from '@/plugins/i18n';
import Inputmask from 'inputmask';
import IranSheba from 'iran-sheba';

export default {
    data() {
        return {
            sheba_number_input_count: 1,
        }
    },
    props: {
        form_meta_data: {
            type: Object,
            default: () => {
                return {
                    submit_btn_progress: false,
                    submit_btn_text: i18n.t('btn.submit'),
                    invalid_sheba_numbers: [],
                };
            },
        },
        on_submit: {
            type: Function,
            default: () => {},
        },
        form_data: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    computed: {
        sheba_numbers_length() {
            if (this.form_data.sheba_numbers.length > 0) {
                return this.form_data.sheba_numbers.length;
            }

            return this.sheba_number_input_count;
        },
        get_sheba_numbers() {
            return this.form_data.sheba_numbers;
        },
    },
    watch: {
        get_sheba_numbers() {
            setTimeout(() => {
                this.initShebaMask();
            }, 1000);
        },
    },
    methods: {
        add_sheba_number_input() {
            if (this.form_data.sheba_numbers.length > 0) {
                this.form_data.sheba_numbers.push('');
            } else {
                ++this.sheba_number_input_count;
            }

            this.recheck_invalid_sheba();
        },
        removeSheba(index) {
            if (this.sheba_numbers_length > 1) {
                if (this.form_data.sheba_numbers.length > 0) {
                    this.form_data.sheba_numbers.splice(index, 1);
                } else {
                    --this.sheba_number_input_count;
                }
            } else {
                this.form_data.sheba_numbers[index] = '';
                $('#sheba_number_1').val('');
            }

            this.recheck_invalid_sheba();
        },
        recheck_invalid_sheba() {
            this.form_meta_data.invalid_sheba_numbers = [];

            for (let i = 0; i < this.sheba_numbers_length; ++i) {
                let value = this.form_data.sheba_numbers[i];

                if (value == '') {
                    continue;
                }

                let sheba = 'IR' + value.split('-').join('');

                if (!IranSheba.isValid(sheba)) {
                    this.form_meta_data.invalid_sheba_numbers.push(i);
                }
            }
        },
        initSelectPicker() {
            setTimeout(() => {
                $('.kt-selectpicker').selectpicker({
                    size: 4,
                    liveSearch: false,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                });
            }, 1000);
        },
        initShebaMask() {
            Inputmask("9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('.sheba_number_inputs'));
        },
    },
    mounted() {
        this.initSelectPicker();
        this.initShebaMask();
    },
}
</script>
